/// <reference types="google.maps" />
import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
import { initParishes } from "./parishes";
import { initTeachingPlaces } from "./teaching_places";
import { initUsers } from "./users";
import { initGroups } from "./groups";

export interface MarkerData {
  lat: number;
  lon: number;
  title: string;
  icon: string;
  details_url: string;
};

export type MarkerWithDetails = google.maps.marker.AdvancedMarkerElement & {
  details_url: string;
  labelEl: HTMLDivElement;
};

export default class extends Controller {
  async connect() {
    console.log('initMap');

    $('body').css('height', '100%');
    $('html').css('height', '100%');
    $('.full-map-header>nav').css('margin-bottom', '0px');
    $(".select2.select2-container").css('width', '100%');

    const apiKey = $('meta[name="google-maps-api-key"]').attr('content');
    setOptions({ key: apiKey });
    await importLibrary("maps");
    await importLibrary("marker");

    const map = new google.maps.Map(
      document.getElementById("mapSimple") as HTMLElement,
      {
        draggableCursor: "default",
        gestureHandling: "greedy",
        mapId: 'MyMapId'
      },
    );

    restoreMapState();

    map.addListener('idle', () => {
      saveMapState();
    });

    $('#toggleMapLabels').on('click', function () {
      $(this).toggleClass('active');
      $(this).blur();
      refreshLabels();
    });

    function refreshLabels() {
      $('#toggleMapLabels').hasClass('active') ? $('.map-labels').show() : $('.map-labels').hide();
    }

    initParishes(map, openPopup);
    initTeachingPlaces(map, openPopup);
    initUsers(map, openPopup);
    initGroups(map, openPopup);
    refreshLabels();

    const infoWindow = new google.maps.InfoWindow();
    async function openPopup(marker: MarkerWithDetails) {
      try {
        const response = await fetch(marker.details_url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const titleEl = doc.querySelector("h5");
        titleEl?.remove(); // remove from body content
        infoWindow.setHeaderContent(titleEl);
        infoWindow.setHeaderDisabled(true);
        infoWindow.setContent(html);
        infoWindow.open({
          map,
          anchor: marker
        });
      } catch (error) {
        console.error("Failed loading marker details", error);
      }
    }

    map.addListener("click", () => {
      infoWindow.close();
    });

    function saveMapState() {
      const center = map.getCenter();
      if (!center) return;

      localStorage.setItem('mapLat', center.lat().toString());
      localStorage.setItem('mapLon', center.lng().toString());
      localStorage.setItem('mapZoom', (map.getZoom() ?? 13).toString());
    }

    function restoreMapState() {
      const lat = Number(localStorage.getItem('mapLat') ?? '47.500855');
      const lon = Number(localStorage.getItem('mapLon') ?? '19.053794');
      const zoom = Number(localStorage.getItem('mapZoom') ?? '13');

      if (!isNaN(lat) && !isNaN(lon) && !isNaN(zoom)) {
        map.setCenter({ lat, lng: lon });
        map.setZoom(zoom);
      }
    }
  }


}